import { ISocialNetworkRepository } from '../../../domain/repositories/social-network.repository.interface';
import { CreateSocialNetworkDTO } from '../../dtos/social-networks/create-social-network.dto';
import { SocialNetwork } from '../../../domain/entities/social-network.entity';

export class CreateSocialNetworkUseCase {
  constructor(private readonly repository: ISocialNetworkRepository) {}

  public async execute(data: CreateSocialNetworkDTO): Promise<SocialNetwork> {
    return this.repository.create(data);
  }
}
